// Vibe-picker chip row used by Draw It Up. Coach taps one chip (or none)
// to seed the Chalk OS prompt.
export function ChipPicker({ chips, selected, onSelect }) {
  return (
    <div>
      <div style={{
        fontSize: 11, textTransform: "uppercase", letterSpacing: "0.08em",
        color: "var(--chalk-muted)", marginBottom: 6,
      }}>
        Pick a vibe
      </div>
      <div style={{ display: "flex", flexWrap: "wrap", gap: 6 }} data-testid="draw-chips">
        {chips.map((c) => {
          const active = selected === c;
          return (
            <button
              key={c}
              type="button"
              data-testid={`draw-chip-${c.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
              onClick={() => onSelect(active ? null : c)}
              style={{
                background: active ? "var(--chalk-board)" : "#fff",
                color: active ? "var(--chalk-white)" : "var(--chalk-board)",
                border: active
                  ? "0.5px solid var(--chalk-board)"
                  : "0.5px solid var(--chalk-border)",
                padding: "6px 12px", borderRadius: 999, fontSize: 12,
                cursor: "pointer", transition: "background 120ms ease",
              }}
            >
              {c}
            </button>
          );
        })}
      </div>
    </div>
  );
}
